import React from 'react';
import {IconButton} from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import LightModeIcon from '@mui/icons-material/WbSunny';
import {themeContext} from './ThemeContext';
// import Menu from 'components/menu/Menu';

export const ThemeToggler = () => {
   const {isDark, setDark} = React.useContext(themeContext);
   return (
      <IconButton onClick={() => setDark(!isDark)} sx={{mr: 1}}>
         {isDark ? <LightModeIcon /> : <Brightness4Icon />}
      </IconButton>
      // <Menu
      //    hoverable
      //    hideExpandIcon
      //    name={
      //       <Box
      //          sx={{
      //             ml: 1,
      //             svg: {
      //                verticalAlign: 'middle',
      //             },
      //             color: isDark ? 'inherit' : 'var(--mui-palette-primary-main)',
      //          }}
      //          onClick={() => setDark(!isDark)}
      //       >
      //          {isDark ? <LightModeIcon /> : <Brightness4Icon />}
      //       </Box>
      //    }
      //    id="theme-menu"
      // >
      //    <ThemeSubMenuItems />
      // </Menu>
   );
};
